import { getStore } from 'cadenza/store/cadenza-store';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import { getNotificationsForView } from 'cadenza/workbook/workbook-core-selectors.state';

import i18n from './advanced-color-classification-settings.properties';

export function isColorClassificationInvalid(viewId: ViewId) {
  return getNotificationsForView(getStore().getState(), viewId)?.some(
    (notification) => notification.type === 'INVALID_COLOR_CLASSIFICATION',
  );
}

export function getColorClassificationInvalidMessage() {
  return i18n('classification-invalid.title');
}
